import PdfFileSvg from 'src/assets/images/pdf.svg';
import styled from 'styled-components';

export const PdfFileIcon = styled(PdfFileSvg)`
  height: 4.375rem;
`;
